var moduleMap = {
	"./advertisements": () => {
		return Promise.all([__webpack_require__.e(995), __webpack_require__.e(709), __webpack_require__.e(451), __webpack_require__.e(672), __webpack_require__.e(401), __webpack_require__.e(719), __webpack_require__.e(67), __webpack_require__.e(5), __webpack_require__.e(332), __webpack_require__.e(69)]).then(() => (() => ((__webpack_require__(12786)))));
	},
	"./menu": () => {
		return Promise.all([__webpack_require__.e(995), __webpack_require__.e(709), __webpack_require__.e(451), __webpack_require__.e(672), __webpack_require__.e(401), __webpack_require__.e(886), __webpack_require__.e(462)]).then(() => (() => ((__webpack_require__(91462)))));
	},
	"./payments": () => {
		return Promise.all([__webpack_require__.e(995), __webpack_require__.e(709), __webpack_require__.e(451), __webpack_require__.e(361)]).then(() => (() => ((__webpack_require__(18361)))));
	},
	"./profile": () => {
		return Promise.all([__webpack_require__.e(346), __webpack_require__.e(995), __webpack_require__.e(709), __webpack_require__.e(451), __webpack_require__.e(672), __webpack_require__.e(401), __webpack_require__.e(319), __webpack_require__.e(67), __webpack_require__.e(5), __webpack_require__.e(286), __webpack_require__.e(135)]).then(() => (() => ((__webpack_require__(37135)))));
	},
	"./single-menu": () => {
		return Promise.all([__webpack_require__.e(995), __webpack_require__.e(709), __webpack_require__.e(451), __webpack_require__.e(672), __webpack_require__.e(401), __webpack_require__.e(319), __webpack_require__.e(5), __webpack_require__.e(886), __webpack_require__.e(21)]).then(() => (() => ((__webpack_require__(44021)))));
	},
	"./profile-form": () => {
		return Promise.all([__webpack_require__.e(346), __webpack_require__.e(995), __webpack_require__.e(709), __webpack_require__.e(672), __webpack_require__.e(401), __webpack_require__.e(286), __webpack_require__.e(644)]).then(() => (() => ((__webpack_require__(73644)))));
	},
	"./ads-popup": () => {
		return Promise.all([__webpack_require__.e(995), __webpack_require__.e(709), __webpack_require__.e(451), __webpack_require__.e(672), __webpack_require__.e(719), __webpack_require__.e(67), __webpack_require__.e(332), __webpack_require__.e(854)]).then(() => (() => ((__webpack_require__(82332)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});